import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';
import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
// import usersAction from '@state/user/actions';
import userActions from '@state/user/actions';
import userApi from '@api/userApi';

function useProfile() {

  // const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const currentUser = useSelector(({ user: a }) => a);
  const dataInit = {
    first_name: currentUser.first_name,
    last_name: currentUser.last_name,
    email: currentUser.email,
    phone: currentUser.phone,
  };
  const idToEdit = currentUser.id;
  const [dataForm, setDataForm] = useState(dataInit);

  const abortC = new AbortController();
  const { signal } = abortC;

  const onFinish = useCallback((values) => { // submit: create device or edit device

    const {
      phone, email, first_name, last_name,
    } = dataForm;
    const body = {
      phone, email, first_name, last_name,
    };

    userApi.updateUserMe({ body, signal })
      .then((response) => {

        dispatch(userActions.userUpdate(response));
        message.info('Usuario editado');

      })
      .catch((resError) => {

        // eslint-disable-next-line
        console.log(resError);
        message.error('Error al editar usuario');

      });

    // eslint-disable-next-line
  }, [dispatch, signal]);

  const onFinishFailed = (errorInfo) => { // data imcomplete

    // eslint-disable-next-line
    console.log(errorInfo.errorFields[0].errors[0]);
    message.error(errorInfo.errorFields[0].errors[0]);

  };

  const formOnValuesChange = useCallback( // handle data of api
    (value) => {

      const key = Object.keys(value);
      const data = Object.values(value);
      setDataForm({ ...dataForm, [key[0]]: data[0] });

    },
    // eslint-disable-next-line
    [dataForm, dispatch]
  );

  const cancelCreateEditUser = useCallback( // cancel: edit user, create user
    () => {

      history.push('/tablero-general/');

    },
    // eslint-disable-next-line
    [],

  );

  return {
    onFinish,
    onFinishFailed,
    formOnValuesChange,
    dataForm,
    idToEdit,
    cancelCreateEditUser,
  };

}

export default useProfile;
